module.exports = require("react-collapse");


//////////////////
// WEBPACK FOOTER
// external "react-collapse"
// module id = 242
// module chunks = 0